import { FC, Fragment, useState } from 'react'
import { StyleAccordionWrapper } from './style'
import Item from './item'
import AccordionLoader from './loader'
interface AccordionProps {
  items: any[]
  titleAsKey: string
  descriptionAsKey?: string
  loading?: boolean
}
const Accordion: FC<AccordionProps> = ({
  items,
  titleAsKey,
  descriptionAsKey,
  loading,
}) => {
  const [active, setActive] = useState<number>(0)
  const handleClick = async (event: any) => {
    const target = event.target as HTMLElement
    const cross = target.closest('[data-cross-index]')
    if (!!cross) {
      const index: any = cross.getAttribute('data-cross-index')
      if (index >= 0) {
        if (index == active) {
          setActive(null)
        } else {
          setActive(index)
        }
      }
    }
  }
  return (
    <StyleAccordionWrapper onClick={handleClick}>
      {!!loading ? (
        <>
          {Array(6)
            .fill(0)
            ?.map((_, index: number) => {
              return (
                <Fragment key={index}>
                  <AccordionLoader />
                </Fragment>
              )
            })}
        </>
      ) : (
        <>
          {!!items?.length &&
            items?.map((item: any, index: number) => {
              return (
                <Fragment key={index}>
                  <Item
                    item={item}
                    title={item[titleAsKey]}
                    description={item[descriptionAsKey]}
                    isActive={active == index}
                    index={index}
                  />
                </Fragment>
              )
            })}
        </>
      )}
    </StyleAccordionWrapper>
  )
}

export default Accordion
